import React from 'react';
import { DEFAULT_PROGRAM_TITLE_SIZE, normalizeProgramTitleSize } from '../../utils/programUtils';

const ProgramBlock = ({ program }) => {
  const events = program.events || [];
  const showTitle = program.titleVisible !== false && Boolean(program.title?.trim());
  const titleSize = normalizeProgramTitleSize(program.titleSize || DEFAULT_PROGRAM_TITLE_SIZE);

  return (
    <>
      <section className="promo">
        <div className="container">
          {showTitle && (
            <h3 className="promo-title" style={{ fontSize: `${titleSize}px` }}>
              {program.title}
            </h3>
          )}
          <div className="promo-box">
            {program.date && (
              <p className="promo-data">Дата проведения: {program.date}</p>
            )}
            {program.format && (
              <p className="promo-format">Формат проведения: {program.format}</p>
            )}
            {program.location && (
              <p className="promo-location">Место проведения: {program.location}</p>
            )}
          </div>
        </div>
      </section>

      {events.length > 0 && (
        <section className="table-section container">
          <div className="table-container">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Время</th>
                  <th>Мероприятие</th>
                  <th>Докладчик</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event, index) => (
                  <tr
                    key={index}
                    className={event.isSelected ? 'is-highlighted' : ''}
                  >
                    <td>{event.EventDate}</td>
                    <td>{event.Event}</td>
                    <td>{event.Speakers}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </>
  );
};

export default ProgramBlock;
